import clsx from 'clsx';
import React from 'react';

import facebookLogo from 'images/facebook_black.svg';
import instagramLogo from 'images/instagram_black.svg';
import linkedinLogo from 'images/linkedin_black.svg';
import twitterLogo from 'images/twitter_black.svg';

import { encodeEntity } from '../../../utils/formatting';
import styles from './styles.module.css';

type theme = 'default' | 'blackBoxStyle';

function SocialLink({
  href,
  src,
  type,
  theme = 'default',
}: {
  href: string;
  src: string;
  type: string;
  theme?: theme;
}) {
  const isBlackBoxStyle = theme === 'blackBoxStyle';
  return (
    <div className={clsx({ [styles.borderLinkWrapper]: isBlackBoxStyle })}>
      <a
        className={clsx(styles.socialLink, { [styles.blackBoxStyle]: isBlackBoxStyle })}
        href={href}
        target="_blank"
        rel="noreferrer"
      >
        <img
          src={src}
          height={isBlackBoxStyle ? '22' : '30'}
          width={isBlackBoxStyle ? '22' : '30'}
          alt={`Social media link: ${type}`}
        />
      </a>
    </div>
  );
}

export default function SocialLinks({
  instagram,
  linkedIn,
  twitter,
  facebook,
  theme = 'default',
}: {
  instagram?: string | null;
  linkedIn?: string | null;
  twitter?: string | null;
  facebook?: string | null;
  theme?: theme;
}) {
  const renderSocialLinks = instagram || linkedIn || twitter || facebook;
  const isBlackBoxStyle = theme === 'blackBoxStyle';

  return (
    <>
      {renderSocialLinks && (
        <div
          className={clsx(styles.socialLinksContainer, {
            [styles.blackBoxStyle]: isBlackBoxStyle,
          })}
        >
          {twitter && (
            <SocialLink
              href={`https://twitter.com/${encodeEntity(twitter)}`}
              src={twitterLogo}
              type="twitter"
              theme={theme}
            />
          )}
          {linkedIn && (
            <SocialLink
              // reinstate "/" back into linked in handle because it might look something like company/handle and don't want to encode the "/"
              href={`https://linkedin.com/${encodeEntity(linkedIn).replace('%2F', '/')}`}
              src={linkedinLogo}
              type="linkedIn"
              theme={theme}
            />
          )}
          {instagram && (
            <SocialLink
              href={`https://instagram.com/${encodeEntity(instagram)}`}
              src={instagramLogo}
              type="instagram"
              theme={theme}
            />
          )}
          {facebook && (
            <SocialLink
              href={`https://facebook.com/${encodeEntity(facebook)}`}
              src={facebookLogo}
              type="facebook"
              theme={theme}
            />
          )}
        </div>
      )}
    </>
  );
}
